import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

// Tenant branding config (N-65 phase 1): fetched once per load from
// /api/tenant, which resolves the tenant from the request host. Consumers
// render the tenant's logo (or a wordmark placeholder) and brand color
// instead of build-time assets.

export interface TenantConfig {
  slug: string;
  name: string;
  logoUrl?: string | null;
  primaryColor?: string | null;
  accentColor?: string | null;
  membershipsEnabled?: boolean;
}

const TenantContext = createContext<TenantConfig | null>(null);

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<TenantConfig | null>(null);

  useEffect(() => {
    api
      .get('/tenant')
      .then((res) => {
        setConfig(res.data);
        if (res.data?.name) document.title = res.data.name;
      })
      .catch(() => {
        // Branding is progressive enhancement — the app works unbranded.
      });
  }, []);

  return <TenantContext.Provider value={config}>{children}</TenantContext.Provider>;
};

export function useTenant(): TenantConfig | null {
  return useContext(TenantContext);
}
